import React from "react";
import { Col, Row } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import styled from "styled-components";

import { useSelector } from "../../../redux/hooks";
import { currentRolesSelector } from "../../../redux/slices/auth/selectors";
import {
    BesuProjectState,
    ProjectStatus,
} from "../../../types/project";
import { isNodeDeveloper, isUserPO } from "../../../utils/role";

import NoProject from "./NoProject";
import ProjectCard from "./ProjectCard";

type ProjectListProps = {
    projects: BesuProjectState[];
};

const ProjectList = ({ projects }: ProjectListProps): JSX.Element => {
    const currentRoles = useSelector(currentRolesSelector);
    const sortedProjects = [...projects].sort((a, b) => {
        return a.name?.localeCompare(b.name);
    });

    if (sortedProjects.length === 0) {
        return <StyledNoProject canCreateProject={isUserPO(currentRoles)} />;
    }

    return (
        <Row xs={3} className="g-5">
            {sortedProjects
                .filter(
                    (project) =>
                        !(
                            isNodeDeveloper() &&
                            project.status === ProjectStatus.PENDING_DELETE
                        ),
                )
                .map((project, index) => (
                    <Col key={index}>
                        <NavLink to={`/project/${project.referenceId}`}>
                            <ProjectCard project={project} />
                        </NavLink>
                    </Col>
                ))}
        </Row>
    );
};

const StyledNoProject = styled(NoProject)`
    margin-top: 240px;
`;

export default ProjectList;
